export default __webpack_public_path__ + "static/media/fallout-item-5.a26c9421.png";